import { renderHtmlToReact } from '@src/utils/html';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box } from 'theme-ui';
type SingleInfoCardProps = {
  item: any;
  index: number;
  selectedButton?: number;
};
const SingleInfoCard = ({
  item,
  index,
  selectedButton,
}: SingleInfoCardProps) => {
  const sectionImage = getImage(item?.image);
  return (
    <Box
      key={index}
      sx={{
        width: '100%',
        marginBottom: ['9px', '49px'],
        display: 'flex',
        gap: ['26px', '70px'],
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection:
          index % 2 === 0 ? ['column', 'row'] : ['column', 'row-reverse'],
      }}
    >
      <Box
        sx={{
          width: ['100%', '50%'],
          height: ['100%', '100%'],
          objectFit: 'cover',
        }}
      >
        {sectionImage && (
          <GatsbyImage
            sx={{
              height: ['234px', '358px'],
              maxWidth: ['100%', '540px'],
              width: ['100%', '540px'],
              minWidth: ['322px', 'auto'],
              borderRadius: '50px',
            }}
            image={sectionImage}
            alt=""
          />
        )}
      </Box>
      <Box
        sx={{
          width: ['100%', '50%'],
        }}
      >
        {selectedButton === 2 && (
          <Box
            sx={{
              fontSize: ['26px', '44px'],
              paddingBottom: [0, '12px'],
              lineHeight: ['34px', '48px'],
              width: index === 2 ? ['243px', '410px'] : 'auto',
            }}
          >
            {item?.title}
          </Box>
        )}

        <Box
          sx={{
            fontSize: '20px',
            lineHeight: '30px',
          }}
        >
          {' '}
          {item?.description?.childMarkdownRemark?.htmlAst &&
            renderHtmlToReact(item.description.childMarkdownRemark.htmlAst)}
        </Box>
      </Box>
    </Box>
  );
};

export default SingleInfoCard;
